import { useLocation } from 'react-router-dom';
import { getAppContextFromPath } from 'src/router/pathUtils';

import { useSelectedApplicationGroupId } from './useSelectedApplicationGroupId';

const useEffectiveApplicationGroupId = () => {
  const location = useLocation();
  const { groupId: groupIdFromPath } = getAppContextFromPath(location.pathname);
  const { selectedGroupId } = useSelectedApplicationGroupId();

  return groupIdFromPath ?? selectedGroupId ?? undefined;
};

export default useEffectiveApplicationGroupId;
